import React, { Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Login, { LoginData } from "./components/Login";
import AuthLayout from "./layout/AuthLayout";
import { authProvider } from "./auth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "react-tabs/style/react-tabs.css";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import "./css/ag-theme-clean.css";
import {
  ChequeEntries,
  UpdateChequeStatus,
  Vendor,
  ChequeTransaction,
  ChequeTransactionPayable,
  VendorEntry,
  Dashboard,
  Reports,
  Users,
  UserMaster,
  Settings,
  Role
} from "./components";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <div className="themeWrapper">
        <Suspense fallback={loading}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/app" element={<AuthLayout />}>
              <Route path="/app" element={<Dashboard />} />
              <Route path="/app/vendor" element={<Vendor />} />
              <Route path="/app/users" element={<Users />} />
              <Route path="/app/role" element={<Role />} />
              <Route path="/app/users/add" element={<UserMaster />} />
              <Route path="/app/vendor/add" element={<VendorEntry />} />
              <Route path="/app/vendor/:id" element={<VendorEntry />} />
              <Route path="/app/cheque" element={<ChequeEntries />} />
              <Route path="/app/settings" element={<Settings />} />
              <Route
                path="/app/cheque/receivables"
                element={<ChequeTransaction isReceivable={1} />}
              />
              <Route
                path="/app/cheque/receivables/:id"
                element={<ChequeTransaction isReceivable={1} />}
              />
              <Route
                path="/app/cheque/payables"
                element={<ChequeTransactionPayable isReceivable={0} />}
              />
              <Route
                path="/app/cheque/payables/:id"
                element={<ChequeTransactionPayable isReceivable={0} />}
              />
              <Route
                path="/app/cheque/update-status"
                element={<UpdateChequeStatus />}
              />
              <Route
                path="/app/reports/date_wise_payable_receivable"
                element={<Reports.PayableReceivable />}
              />
              <Route
                path="/app/reports/overdue_cheque_details"
                element={<Reports.OverdueCheques />}
              />
              <Route
                path="/app/reports/vendor_cheque_details"
                element={<Reports.VendorChequeDetails />}
              />
            </Route>
          </Routes>
        </Suspense>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          theme="colored"
        ></ToastContainer>
      </div>
    </AuthProvider>
  );
}

export default App;

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  let auth = useAuth();
  let location = useLocation();

  if (!auth.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

interface AuthContextType {
  user: any;
  signin: (user: LoginData, onSuccess: any, onError: any) => void;
  signout: (callback: VoidFunction) => void;
}

let AuthContext = React.createContext<AuthContextType>(null!);
export const useAuth = () => {
  return React.useContext(AuthContext);
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  let [user, setUser] = React.useState<any>(null);

  let signin = (newUser: LoginData, onSuccess: any, onError: any) => {
    return authProvider.signin(
      newUser,
      (res: any) => {
        setUser(res);
        onSuccess(res);
        //callback();
      },
      (e: any) => {
        onError(e);
      }
    );
  };

  let signout = (callback: VoidFunction) => {
    return authProvider.signout(() => {
      setUser(null);
      callback();
    });
  };

  let value = { user, signin, signout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
